import './index.scss';
import Select, {components} from 'react-select';
import React, { useEffect, useState } from 'react';
import manager from '../../Manager';

function SelectControl({structure, saveValue, defaultValue}){
    var options = structure.lists.filter(item => item.value !== 'amazon');
    const networkAccountId = manager.settings.networkAccountId;
    const networkAccountIdAllowedS3Audio = manager.settings.networkAccountIdAllowedS3Audio ?? [];
    if (networkAccountIdAllowedS3Audio.length > 0 && networkAccountIdAllowedS3Audio.includes(networkAccountId)) {
        options = structure.lists;
    }

    const defaultSelectionOption = options.find(option => option.value === defaultValue);
    const [selectedOption, setSelectedOption] = useState( defaultSelectionOption ?? null);
    const [currentValue, setCurrentValue] = useState(defaultValue ?? '');


    const { Option } = components;
    const IconOption = props => (
        <Option {...props}>
            <span className='option-icon'>
                {props.data.icon}
            </span>
            {props.data.label}
        </Option>
    );

    const getOptionLabel = (option) => (
        <div className='form-select-custom__option'>
            <span className='option-icon'>
                {option.icon}
            </span>
            {option.label}
        </div>
    );

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        setCurrentValue(selectedOption.value);
        saveValue(selectedOption.value);
    };

    // const selectDefaultValue = options[]

    // console.log('selectedOption', selectedOption);
    // console.log('optiopns',options[0]);

    useEffect(()=>{
        if(typeof defaultSelectionOption !== 'undefined') {
            setSelectedOption(defaultSelectionOption);
        } else {
            setSelectedOption(null);
        }
    }, [defaultSelectionOption]);

    return (
        <div className="tbcourse-editor-control-select">
            <Select
                // name=''
                options={options}
                className='form-select-custom'
                components={{ Option: IconOption }}
                getOptionLabel={getOptionLabel}
                classNamePrefix="form-select-custom"
                // menuIsOpen={true}    // force open for editing styles
                isSearchable={false}
                onChange={handleChange}
                value={selectedOption}
                placeholder={structure.placeholder}
                isOptionDisabled={(option) => option.isDisabled}
            />
        </div>
    );
}

export default SelectControl;
